import React from "react";
import { kebabCase, map } from "lodash";
import { formatSuffixedParams } from "@backpacker/intl";
import { Spacing } from "@glossy";
import { Locale } from "@linkfluence/models/locale";
import { x } from "@xstyled/styled-components";
import { tr } from "@radarly/i18n";
import { widthFromLayout } from "@radarly/models/insight-pages/layout";
import { TitleRow } from "@radarly/models/insight-pages/model";
import { hasDynamicTitles } from "@radarly/models/insight-pages/row";
import { InsightPagesLayoutRowsProps } from "../discovery/layout/types";

interface TitleRowProps {
  row: TitleRow;
  id: number;
  locale: Locale;
  renderTitle: InsightPagesLayoutRowsProps["renderTitle"];
  isFirstSectionTitle?: boolean;
}

const renderTitleItem = (
  row: TitleRow,
  index: number,
  title: string = null,
  rowId: number,
  renderTitle: InsightPagesLayoutRowsProps["renderTitle"],
  isFirstSectionTitle?: boolean
) => (
  <x.div
    id={`title_${kebabCase(title)}`}
    col={{ xs: 1, sm: widthFromLayout(row.layout, index) }}
    px={Spacing.Medium}
    mb={Spacing.MediumLarge}
    key={index}
  >
    {title &&
      renderTitle(title, row.style, rowId, isFirstSectionTitle, row.icon)}
  </x.div>
);

const TitleRowComponent = ({
  row,
  id,
  locale,
  renderTitle,
  isFirstSectionTitle,
}: TitleRowProps) => (
  <>
    {hasDynamicTitles(row)
      ? map(row.dynamicTitles, (dynamicTitle, index) =>
          renderTitleItem(
            row,
            index,
            tr(
              locale,
              dynamicTitle.key,
              formatSuffixedParams(dynamicTitle.params, locale)
            ),
            id,
            renderTitle,
            isFirstSectionTitle
          )
        )
      : map(row.titles, (title, index) =>
          renderTitleItem(
            row,
            index,
            title,
            id,
            renderTitle,
            isFirstSectionTitle
          )
        )}
  </>
);

export default TitleRowComponent;
